:host {
    display: block;
    background-color: rgba(0, 0, 0, 0.32);
    height: 100%;

    .grid {
        @include grid;

        align-items: center;
        height: 100%;
    }

    .box {
        grid-column: 6 / -6;
        background-color: var(--color-background-interaction-secondary-default);
        box-shadow: var(--shadow-large);
        padding-top: 100%;
        position: relative;
    }

    .content {
        display: grid;
        grid-template-rows: 1fr min-content;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 16px 24px 24px;
    }

    .player {
        overflow: hidden;
    }

    .player > * {
        height: 100%;
        width: 100%;
    }

    p {
        @include font-p-default;

        color: var(--color-text-default);
        text-align: center;
        margin: 24px 0 0;
    }
}

@media (width <= 1400px) {
    :host .box {
        grid-column: 5 / -5;
    }
}

@include mq-1 {
    :host {
        .box {
            grid-column: 2 / -2;
        }
    }
}
